<div
    class="visibility-top"
    (visibilityNotifier)="scrollTopButton = false"
    (invisibilityNotifier)="scrollTopButton = true"
>
</div>
<!--<circle-shimmer-->
<!--    [ngStyle.xs]="{ 'margin-left': '14px' }"-->
<!--    [ghosts]="headerGhosts"-->
<!--    fxLayout="row"-->
<!--&gt;</circle-shimmer>-->
<div class="page-fullscreen listing" fxLayout="column">
    <!--    <img-->
    <!--        *ngIf="errors.length === 0 && headerData?.text"-->
    <!--        (click)="backButton()"-->
    <!--        src="https://images.dailyobjects.com/icons/arrow.png"-->
    <!--        class="back-button"-->
    <!--        fxShow-->
    <!--        fxShow.gt-xs="false"-->
    <!--        fxFlexAlign="flex-start"-->
    <!--    />-->

    <div
        *ngIf="
            headerData?.banner?.layout === '1-col-medium-strip-banner' &&
            !errorCaught
        "
        class="medium-extra-container"
        [ngStyle.xs]="{ paddingTop: '0%' }"
        (click)="
            headerData?.banner.link.includes('http://')
                ? externalLinksRedirect(headerData?.banner.link)
                : processLink(headerData?.banner.link)
        "
    >
        <picture
            class="medium-extra-strip"
            *ngIf="!headerData?.banner?.video"
            [ngClass]="{ 'image-banner-shimmer': showShimmer }"
        >
            <img
                class="medium-extra-strip__image"
                src="{{ headerData?.banner?.image }}"
                appImageCDN
            />
        </picture>
        <!--Video-->
        <video
            *ngIf="headerData?.banner?.video"
            poster="{{ headerData?.banner?.image }}"
            style="border: none; height: auto; width: 100%"
            loop
            muted
            autoplay
            oncanplay="this.play()"
            onloadedmetadata="this.muted = true"
            playsinline
            webkit-playsinline
        >
            <source src="{{ headerData?.banner?.video }}" type="video/webm" />
            <!-- <source
              [src]="convertWebToMp4(headerData?.banner?.video)"
              type="video/mp4"
          /> -->
        </video>
    </div>
    <div
        *ngIf="
            headerData?.banner?.layout === '1-col-extra-offer-strip-banner' &&
            !errorCaught
        "
        class="offer-extra-container"
        [ngStyle.xs]="{ paddingTop: '0%' }"
        (click)="
            headerData?.banner.link.includes('http://')
                ? externalLinksRedirect(headerData?.banner.link)
                : processLink(headerData?.banner.link)
        "
    >
        <picture
            class="offer-extra-strip"
            *ngIf="!headerData?.banner?.video"
            [ngClass]="{ 'image-offer-shimmer': showShimmer }"
        >
            <img
                class="offer-extra-strip__image"
                src="{{ headerData?.banner?.image }}"
                appImageCDN
            />
        </picture>
        <video
            *ngIf="headerData?.banner?.video"
            poster="{{ headerData?.banner?.image }}"
            style="
                border: none;
                position: absolute;
                top: 0;
                height: auto;
                width: 100%;
            "
            loop
            muted
            autoplay
            oncanplay="this.play()"
            onloadedmetadata="this.muted = true"
            playsinline
            webkit-playsinline
        >
            <source src="{{ headerData?.banner?.video }}" type="video/webm" />
            <!-- <source
  [src]="convertWebToMp4(headerData?.banner?.video)"
  type="video/mp4"
  /> -->
        </video>
    </div>
    <div
        *ngIf="
            headerData?.banner?.layout === '1-col-offer-h131-strip-banner' &&
            !errorCaught
        "
        class="offer-extra-container"
        [ngStyle.xs]="{ paddingTop: '0%' }"
        (click)="
            headerData?.banner.link.includes('http://')
                ? externalLinksRedirect(headerData?.banner.link)
                : processLink(headerData?.banner.link)
        "
    >
        <picture
            class="offer-extra-strip"
            *ngIf="!headerData?.banner?.video"
            [ngClass]="{ 'image-offer-shimmer': showShimmer }"
        >
            <img
                class="offer-extra-strip__image"
                src="{{ headerData?.banner?.image }}"
                appImageCDN
            />
        </picture>
        <video
            *ngIf="headerData?.banner?.video"
            poster="{{ headerData?.banner?.image }}"
            style="
                border: none;
                position: absolute;
                top: 0;
                height: auto;
                width: 100%;
            "
            loop
            muted
            autoplay
            oncanplay="this.play()"
            onloadedmetadata="this.muted = true"
            playsinline
            webkit-playsinline
        >
            <source src="{{ headerData?.banner?.video }}" type="video/webm" />
            <!-- <source
  [src]="convertWebToMp4(headerData?.banner?.video)"
  type="video/mp4"
  /> -->
        </video>
    </div>
    <div
        *ngIf="
            headerData?.banner?.layout === 'listing-full-banner' && !errorCaught
        "
        class="one-col-banner one-col-banner-mobile"
        ngClass.gt-xs="one-col-banner-desktop"
    >
        <picture
            class="one-col-banner-image"
            *ngIf="!headerData?.banner?.video"
            [ngClass]="{ 'image-banner-shimmer': showShimmer }"
        >
            <img
                class="image-holder"
                src="{{ headerData?.banner?.image }}"
                appImageCDN
            />
        </picture>
        <!--Video-->
        <video
            *ngIf="headerData?.banner?.video"
            poster="{{ headerData?.banner?.image }}"
            style="
                border: none;
                position: absolute;
                top: 0;
                height: 247px;
                width: 100%;
                object-fit: cover;
            "
            loop
            muted
            autoplay
            oncanplay="this.play()"
            onloadedmetadata="this.muted = true"
            playsinline
            webkit-playsinline
        >
            <source src="{{ headerData?.banner?.video }}" type="video/webm" />
            <!-- <source
        [src]="convertWebToMp4(headerData?.banner?.video)"
        type="video/mp4"
    /> -->
        </video>
    </div>
    <div
        *ngIf="headerData?.timerStrip?.layout === 'timer-strip' && isTimerStrip"
        class="timer-strip"
        [ngStyle.xs]="{ paddingTop: '0%' }"
    >
        <picture
            class="timer-extra-strip"
            [ngClass]="{ 'image-offer-shimmer': showShimmer }"
        >
            <img
                class="timer-extra-strip__image"
                src="{{ headerData?.timerStrip?.banner?.image }}"
                appImageCDN
            />
        </picture>

        <div
            [fxFlex]="getFlex(headerData?.timerStrip)"
            style="background-color:{{
                headerData?.timerStrip?.banner?.background
            }}"
            [fxFlexOrder]="getFlexOrder(headerData?.timerStrip)"
            fxLayoutAlign="center center"
            fxLayout="row"
            class="timer-section"
        >
            <p></p>
            <div class="headline">
                <h1 style="color:{{ headerData?.timerStrip?.title?.color }}">{{
                    headerData?.timerStrip?.title?.text
                }}</h1>
            </div>
            <div class="countdown">
                <ul style="color:{{ headerData?.timerStrip?.title?.color }}">
                    <li *ngIf="day >= 1"
                        ><span>{{ day | number: '2.0-0' }}</span
                        >Day</li
                    >
                    <li *ngIf="day >= 1" class="bullets">:</li>
                    <li
                        ><span>{{ hours | number: '2.0-0' }}</span
                        >Hours</li
                    >
                    <li class="bullets">:</li>
                    <li
                        ><span>{{ mins | number: '2.0-0' }}</span
                        >Minutes</li
                    >
                    <span *ngIf="day < 1">
                        <li class="bullets">:</li>
                        <li
                            ><span>{{ seconds | number: '2.0-0' }}</span
                            >Seconds</li
                        >
                    </span>
                </ul>
            </div>
        </div>
    </div>
    <div
        *ngIf="
            headerData?.timerStrip?.layout === 'timer-strip-v2' &&
            isTimerStripV2
        "
        class="timer-strip"
        [ngStyle.xs]="{ paddingTop: '0%' }"
    >
        <picture
            class="timer-extra-strip"
            [ngClass]="{ 'image-offer-shimmer': showShimmer }"
        >
            <img
                class="timer-extra-strip__image"
                src="{{ headerData?.timerStrip?.banner?.image }}"
                appImageCDN
            />
        </picture>

        <div
            [fxFlex]="getFlex(headerData?.timerStrip)"
            style="background-color:{{
                headerData?.timerStrip?.banner?.background
            }}"
            [fxFlexOrder]="getFlexOrder(headerData?.timerStrip)"
            fxLayoutAlign="center center"
            fxLayout="row"
            class="timer-section"
        >
            <p></p>
            <div class="headline">
                <h1 style="color:{{ headerData?.timerStrip?.title?.color }}">{{
                    headerData?.timerStrip?.title?.text
                }}</h1>
            </div>
            <div class="countdown">
                <ul style="color:{{ headerData?.timerStrip?.title?.color }}">
                    <li *ngIf="day >= 1"
                        ><span>{{ day | number: '2.0-0' }}</span
                        >Day</li
                    >
                    <li *ngIf="day >= 1" class="bullets">:</li>
                    <li
                        ><span>{{ hours | number: '2.0-0' }}</span
                        >Hours</li
                    >
                    <li class="bullets">:</li>
                    <li
                        ><span>{{ mins | number: '2.0-0' }}</span
                        >Minutes</li
                    >
                    <span *ngIf="day < 1">
                        <li class="bullets">:</li>
                        <li
                            ><span>{{ seconds | number: '2.0-0' }}</span
                            >Seconds</li
                        >
                    </span>
                </ul>
            </div>
        </div>
    </div>
    <p
        class="listing-title title-shimmer"
        ngClass.gt-xs="listing-title-desktop"
        fxFlexAlign="start"
        fxFlexAlign.gt-xs="center"
        *ngIf="showHeaderShimmer"
    ></p>
    <app-listing-title
        *ngIf="errors.length === 0 && !showHeaderShimmer"
        [listingTitleData]="headerData"
        class="listing-title"
        ngClass.gt-xs="listing-title-desktop"
        fxFlexAlign="start"
        fxFlexAlign.gt-xs="center"
    ></app-listing-title>

    <div
        *ngIf="headerData?.action?.link && errors.length === 0"
        (click)="processLink(headerData?.action?.link)"
        class="listing-action"
        fxLayout
        fxLayoutAlign="space-between center"
        fxShow
        fxShow.gt-xs="false"
    >
        <button
            mat-button
            class="listing-action__text"
            fxFlex="1 0 auto"
            fxLayoutAlign="start"
            >{{ headerData?.action?.text }}</button
        >
        <img
            src="https://images.dailyobjects.com/icons/arrow_down.png"
            class="listing-action__icon"
        />
    </div>

    <circle-shimmer
        *ngIf="showHeaderShimmer"
        [ngStyle.xs]="{ 'margin-left': '14px' }"
        [ghosts]="headerGhosts"
        fxLayout="row"
    ></circle-shimmer>
    <app-style-container-listing
        *ngIf="headerData?.styles && errors.length === 0"
        (processLink)="processLink($event)"
        [styles]="headerData?.styles"
        radius="normal"
        class="listing-styles-item"
        ngClass.gt-xs="listing-style-item-desktop"
        fxLayoutAlign="start"
        fxLayoutAlign.gt-xs="center"
        [margin]="15"
        [padding]="15"
    ></app-style-container-listing>
    <div
        *ngIf="errors.length === 0"
        class="listing-content-filters-holder"
        fxHide
        fxHide.gt-xs="false"
        fxLayout="row"
        fxLayoutAlign="space-between"
    >
        <span
            (click)="openBrandModel()"
            class="secondary-filter-button model-change"
            >{{ headerData?.action?.text }}</span
        >
        <span (click)="openFilterSort()" class="secondary-filter-button filter">
            Filters
        </span>
    </div>
    <div
        class="listing-content-holder"
        ngClass.gt-xs="listing-content-holder-desktop"
        fxLayout="row"
        fxLayoutAlign="space-between"
    >
        <app-error-page
            *ngIf="errors.length > 0"
            style="width: 100%; overflow: hidden"
            [error]="errors"
        ></app-error-page>
        <!-- Change Model -->
        <div
            *ngIf="errors.length === 0 && headerData.action !== null"
            [@pushModel]="stateModelChangeName"
            fxHide.lt-md
        >
            <app-req-filters-page
                style="width: 100%"
                [asHTMLTag]="true"
                [filter]="rfpFilter"
            ></app-req-filters-page>
        </div>
        <div
            *ngIf="errors.length === 0"
            [ngStyle.xs]="{ marginRight: '8px', marginLeft: '8px' }"
            style="width: 100%; overflow: hidden"
        >
            <div
                fxLayout="row wrap"
                fxLayoutAlign.xs="space-between start"
                style="width: 100%; overflow: hidden"
            >
                <ng-container *ngIf="showShimmer">
                    <app-content-item
                        *ngFor="let item of contentItems?.feed"
                        fxFlex="0 0 calc({{
                            getWidthOnMobileItem(item?.layout)
                        }}%)"
                        fxFlex.gt-xs="0 0 calc({{
                            getWidthOfItem(item?.layout)
                        }}%)"
                        fxLayout="column"
                        [ngStyle.gt-xs]="{ paddingRight: '1.3%' }"
                        (processLink)="processLink($event)"
                        [item]="item"
                        [scrollingType]="'vertical'"
                        [onChangeFire]="fireChanges"
                    >
                    </app-content-item>
                    <content-item-shimmer
                        fxLayout="column"
                        fxFlex="0 0 49%"
                        [ngStyle.gt-xs]="{ marginRight: '2%' }"
                        fxFlex.gt-xs="0 0 23%"
                        *ngFor="let item of contentGhosts"
                    >
                    </content-item-shimmer>
                </ng-container>
            </div>
        </div>
        <!-- Filter and Sort -->
        <div
            *ngIf="errors.length === 0"
            [@pushFilter]="stateFilterName"
            fxHide.lt-md
            [ngStyle.gt-xs]="{ paddingLeft: filterSortDiv ? '10px' : '0' }"
        >
            <app-listing-filter-page
                *ngIf="filterSortDiv && !collectionListingVisible"
                asHTMLTag="true"
                [filter]="filters"
            >
            </app-listing-filter-page>
            <app-collection-listing-filter-page
                *ngIf="filterSortDiv && collectionListingVisible"
                asHTMLTag="true"
                [filter]="filters"
            >
            </app-collection-listing-filter-page>
        </div>
    </div>
    <div
        *ngIf="!noDataLeft"
        style="height: 20px"
        (visibilityNotifier)="
            processLink('/fn/pagination?f=' + page + '&action=pagination')
        "
    >
    </div>
    <div *ngIf="!loading && nextPageLoading">
        <mat-progress-spinner
            class="page-spinner listing-spinner"
            mode="indeterminate"
            diameter="40"
            strokeWidth="5"
            value="5"
        ></mat-progress-spinner>
    </div>
    <div
        class="listing-footer-content"
        *ngIf="!!footerContent && !errorCaught"
        [innerHTML]="footerContent"
    >
    </div>
    <div *ngIf="!!seoTable && !errorCaught" class="tab-content">
        <h3 class="T-heading">{{ seoTable?.text }} </h3>
        <table [ngStyle.xs]="{ width: '100%' }">
            <thead>
                <th>{{ seoTable?.header[0] }}</th>
                <th style="width: 20%">{{ seoTable?.header[1] }}</th>
            </thead>
            <tr *ngFor="let row of seoTable?.rows">
                <td (click)="processLink(row[0].link)" style="cursor: pointer">
                    <a
                        class="Acnhor"
                        [routerLink]="[row[0].link | pageIdFromLink]"
                        [queryParams]="row[0].link | queryParamFromLink"
                    >
                        {{ row[0].text }}
                    </a>
                </td>
                <td>{{ row[1].text }}</td>
            </tr>
        </table>
        <p class="footer-des">{{ seoTable?.description }}</p>
    </div>
</div>

<button
    *ngIf="filterData?.icon.length !== 0 && errors.length === 0"
    (click)="processLink(filterData?.link)"
    mat-fab
    class="button-round left-42"
    fxLayout
    fxShow
    fxShow.gt-xs="false"
    fxLayoutAlign="center center"
>
    <img class="lfp-icon" src="{{ filterData.icon }}" appImageCDN />
</button>
<button
    *ngIf="scrollTopButton"
    (click)="processLink('/fn/?action=scroll-to-top')"
    mat-fab
    class="button-round right-8"
    fxLayoutAlign="center center"
>
    <img
        class="lfp-icon button-top"
        src="https://images.dailyobjects.com/icons/right_arrow_black.png"
    />
</button>
<app-footer-v2
    *ngIf="errors.length === 0"
    [filter]="filters"
    [page]="'lp'"
></app-footer-v2>
<app-offer-toggle [page]="'lp'"></app-offer-toggle>
